export default "__VITE_ASSET__BLY19OuY__"